<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="orders" search pagination max-items="10">
      <template>
        <h3>
          Rendelések
        </h3>
      </template>
      <template>
        <vs-th>
          Név
        </vs-th>
        <vs-th>
          Cím
        </vs-th>
        <vs-th>
          Telefonszám
        </vs-th>
        <vs-th>
          E-mail
        </vs-th>
        <vs-th>
          Rendelés ideje
        </vs-th>
        <vs-th>
          Szállítás ideje
        </vs-th>
        <vs-th>
          Átvétel módja
        </vs-th>
        <vs-th>
          Fizetés módja
        </vs-th>
        <vs-th>
          Végösszeg
        </vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.CustomerName }}
          </vs-td>
          <vs-td style="max-width: 250px;">
            {{ tr.CustomerAddress }}
          </vs-td>
          <vs-td>
            {{ tr.CustomerPhone }}
          </vs-td>
          <vs-td>
            {{ tr.CustomerEmail }}
          </vs-td>
          <vs-td>
            {{ tr.OrderDate }}
          </vs-td>
          <vs-td>
            {{ tr.ShippingDate }}
          </vs-td>
          <vs-td>
            {{ tr.Shipping }}
          </vs-td>
          <vs-td>
            {{ tr.Payment }}
          </vs-td>
          <vs-td>
            {{ tr.Total }} HUF
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button v-if="tr.TransactionId" radius color="success" size="small" type="gradient" icon="autorenew"
                         @click="queryOrderStatus(tr.OrderRef)"></vs-button>
              <vs-button radius color="warning" size="small" type="gradient" icon="build"
                         @click="orderDetail(tr.OrderId)"></vs-button>
              <vs-button radius color="danger" size="small" type="gradient" icon="cancel"
                         @click="deleteOrder(tr.OrderId)"></vs-button>

            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="centerx">
      <vs-popup classContent="orderDetailModal" title="Rendelés részletei" :active.sync="editModal"
                @closemodal="closeModal()">
        <order_detail v-bind:selectedOrder="selected"></order_detail>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import order_detail from "@/components/modals/order_detail";

export default {
  name: "orders",
  data() {
    return {
      orderInterval: null,
      editModal: false,
      orders: [],
      selected: '',
    }
  },
  components: {order_detail},
  methods: {
    closeModal() {
      this.editModal = false;
      this.getOrders();
    },
    getOrdersController() {
      let self = this;
      if (self.$store.state.user.poll) {
        this.getOrders();
        setTimeout(this.getOrdersController, 60000);
      }
    },
    getOrders() {
      let self = this;
      let orderLen = self.orders.length;
      axiosInstance
          .get("admin/placeOrderController.php", {
            withCredentials: true,
          })
          .then((resp) => {
            self.orders = resp.data.responseData;
            if (parseInt(orderLen) > 0 && parseInt(self.orders.length) > parseInt(orderLen)) {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: 'Új rendelés érkezett',
                color: 'success',
                icon: 'check',
                fixed: true
              });
            }
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    queryOrderStatus(ref) {
      let self = this;
      axiosInstance
          .post("admin/queryOrderStatus.php", {ref: ref}, {
            withCredentials: true,
          })
          .then(() => {
            self.getOrders();
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    orderDetail(id) {
      this.selected = {...this.orders.find(elem => elem.OrderId === id)};
      this.editModal = true;
    },
    deleteOrder(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja a rendelést?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/placeOrderController.php?id=' + id, {
                withCredentials: true,
              })
              .then((resp) => {
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
                self.getOrders();
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    },
  },
  mounted() {
    this.getOrdersController();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>